"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var shallowEqual = function shallowEqual(a, b) {
  var keysA = Object.keys(a);
  var keysB = Object.keys(b);

  return keysA.length === keysB.length && keysA.every(function (key) {
    return b.hasOwnProperty(key) && b[key] === a[key];
  });
};

exports.default = shallowEqual;


//////////////////
// WEBPACK FOOTER
// ./~/react-stripe-elements/lib/utils/shallowEqual.js
// module id = 1018
// module chunks = 0